export default __webpack_public_path__ + "static/media/Ambassador.bec06530.jpg";